<template>
	<el-select
		ref="el-select"
		remote
		:filterable="filterable"
		:value="value"
		:placeholder="placeholder"
		:clearable="clearable"
		:remote-method="handleSearch"
		:loading="loading"
		:multiple="multiple"
		:collapse-tags="collapseTags"
		@clear="reset"
		@visible-change="visibleChange"
		v-bind="$attrs"
		v-on="$listeners"
		v-loadmore="loadMore"
	>
		<el-option
			v-for="item in options"
			:key="item[dictValue]"
			:label="item[dictLabel]"
			:value="item[dictValue]"
		></el-option>

		<el-option v-if="hasMore" disabled label="加载中..." value="-1"></el-option>
		<slot slot="prefix" name="prefix"></slot>
	</el-select>
</template>

<script>
export default {
	props: {
		placeholder: String,
		value: {
			type: [String, Number, Array]
		},
		options: {
			type: Array,
			default: () => []
		},
		dictLabel: {
			type: String,
			default: 'name'
		},
		dictValue: {
			type: String,
			default: 'id'
		},
		clearable: {
			type: Boolean,
			default: true
		},
		// 调用页数的接口
		request: {
			type: Function,
			default: () => {},
			required: true
		},
		// last_page 需要在拿到数据后存进来
		paginate: {
			type: Object,
			default: () => {
				return { page: 1, size: 20, last_page: null }
			}
		},
		filterable: {
			type: Boolean,
			default: true
		},
		multiple: {
			type: Boolean,
			default: false
		},
		collapseTags: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			// 存储关键字用
			keyword: '',
			loading: false
		}
	},
	computed: {
		hasMore() {
			// 检测页码是否还有更多数据
			return this.paginate.page < this.paginate.last_page
		}
	},
	methods: {
		// 请求下一页的数据
		loadMore() {
			// 如果没有更多数据，则不请求
			if (!this.hasMore) {
				return
			}
			this.request({ page: this.paginate.page + 1, size: this.paginate.size }, true, this.keyword)
		},
		// 关键字搜索
		handleSearch(keyword) {
			this.keyword = keyword
			this.loading = true
			this.request({ page: 1, size: this.paginate.size }, false, keyword).then(() => {
				this.loading = false
			})
		},
		visibleChange(val) {
			// 搜索过，缩回来选择框的时候重置选项
			if (!val && this.keyword && this.keyword.length > 0) {
				this.reset()
			}
		},
		reset() {
			this.keyword = ''
			this.request({ page: 1, size: this.paginate.size })
		}
	}
}
</script>
